<template>
  <div class="page-wrap">
    <apply-online></apply-online>
    <Bottom></Bottom>
  </div>
</template>
<script>
import ApplyOnline from "./components/ApplyOnline.vue";
import Bottom from "@/components/Bottom.vue";
import Header from "@/components/Header.vue";
export default {
  components: { ApplyOnline, Bottom, Header },
  data() {
    return {};
  },

  methods: {},
};
</script>
<style lang="less" scoped>
</style>
